import { IHeatParameter, IResult } from "@/types/map";
import Heatmap from 'ol/layer/Heatmap';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

export class HeatMapOpenlayers {
    private static instances: Map<string, any>;
    private map!: any;
    private heatLayer!: any;

    private constructor(map: any) {
        this.map = map;
    };
    
    public static getInstance(map: any){
        let id = map.getTarget();
        console.log(id);
        if (!HeatMapOpenlayers.instances) {
            HeatMapOpenlayers.instances = new Map();
        }
        let intance = HeatMapOpenlayers.instances.get(id);
        if (!intance) {
          intance = new HeatMapOpenlayers(map);
          HeatMapOpenlayers.instances.set(id, intance);
        }
        return intance;
    }
    public static destroy() {
        (HeatMapOpenlayers.instances as any) = null;
    }
    //清空指定热力图
    private clear(labels: string[]) {
        // if (this.heatlayers) {
        //     for (let i = 0; i < this.heatlayers.length; i++) {
        //         let layer = this.heatlayers[i];
        //         if (
        //             labels === undefined ||
        //             labels.length == 0 ||
        //             labels.indexOf(layer.label) > -1
        //         ) {
        //             this.view.map.remove(layer);
        //             this.heatlayers.splice(i, 1);
        //             i--;
        //         }
        //     }
        // }
    }
    //添加热力图
    public async addHeatMap(params: IHeatParameter): Promise<IResult> {
        console.log("创建热力图：");
        console.log(params);
        // let label = params.label;
        // if (label == undefined) {
        //     this.clear([]);
        // } else {
        //     this.clear([label]);
        // };
        // let points = 
        // this.heatLayer = new HeatmapLayer({
        //     source: new VectorSource(),
        //     opacity: params.options.opacity || 1,
        //     radius: params.options.radius,
        //     gradient: params.options.colors,
        //     maxZoom: params.options.maxZoom,
        //     minZoom: params.options.minZoom,
        // });
        // this.map.addLayer(this.heatLayer);
        // this.heatLayer.getSource().addFeatures(params.points);
        // const heatmapLayer = new Heatmap({
        //     // zIndex: 1,
        //     // source: new VectorSource({}),
        //     // radius: params.options.radius,
        // });
        // this.map.addLayer(heatmapLayer);

        let highMarkLayer = new VectorLayer({// 设置点位图层
            source: new VectorSource(),
            style: () => {},
        });




        return {
            status: 0,
            message: "success!",
        };
    }




}